import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { COMPONENT_TYPES, modelOptionLabel } from '../firmwareForm';
import { AddFirmwareState } from './useAddFirmware';

/** What the firmware is: model, component, version, and the version it upgrades from. */
export const FirmwareInfoSection: React.FC<{ state: AddFirmwareState }> = ({ state }) => {
  const { t } = useI18n();
  const { form, errors, submitting, models } = state;

  return (
    <div className="device-section">
      <h3 className="section-title">{t('otaUpdates.firmwareInformation')}</h3>
      <div className="firmware-fields">
        <div className="form-field">
          <label className="required">{t('otaUpdates.deviceModel')}</label>
          <select
            value={form.model}
            data-testid="field-firmware-device-model"
            onChange={(e) => state.setField('model', e.target.value)}
            disabled={submitting || models.length === 0}
            className={`field-select ${errors.model ? 'error' : ''}`}
          >
            {models.length === 0
              ? <option value="">{t('otaUpdates.loadingModels')}</option>
              : models.map((model) => <option key={model.code} value={model.code}>{modelOptionLabel(model)}</option>)}
          </select>
          {errors.model && <span className="field-error">{errors.model}</span>}
        </div>

        <div className="form-field">
          <label className="required">{t('otaUpdates.componentType')}</label>
          <select
            value={form.type}
            data-testid="field-firmware-component-type"
            onChange={(e) => state.setField('type', e.target.value)}
            disabled={submitting}
            className={`field-select ${errors.type ? 'error' : ''}`}
          >
            {COMPONENT_TYPES.map((type) => <option key={type} value={type}>{type}</option>)}
          </select>
          {errors.type && <span className="field-error">{errors.type}</span>}
        </div>

        <div className="form-field">
          <label className="required">{t('otaUpdates.version')}</label>
          <input
            type="text"
            data-testid="field-firmware-version"
            value={form.version}
            onChange={(e) => state.setField('version', e.target.value)}
            placeholder={t('otaUpdates.versionPlaceholder')}
            disabled={submitting}
            className={`field-input ${errors.version ? 'error' : ''}`}
            maxLength={50}
          />
          {errors.version && <span className="field-error">{errors.version}</span>}
        </div>

        <div className="form-field">
          <label>{t('otaUpdates.fromVersion')}</label>
          <input
            type="text"
            value={form.from_version}
            onChange={(e) => state.setField('from_version', e.target.value)}
            placeholder={t('otaUpdates.fromVersionPlaceholder')}
            disabled={submitting}
            className="field-input"
            maxLength={50}
          />
          <span className="field-hint">{t('otaUpdates.leaveEmptyUpgradeAny')}</span>
        </div>
      </div>
    </div>
  );
};
